import React from 'react';
import { DrawStatus } from '@apply/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faClock,
    faEnvelope,
    faHouseCircleExclamation,
    faTruckArrowRight,
    faBank,
    faCheckSquare,
} from '@fortawesome/free-solid-svg-icons';

interface DrawStatusBubbleParameters {
    drawStatus: DrawStatus;
}

export const DrawStatusBubble: React.FC<DrawStatusBubbleParameters> = ({ drawStatus }) => {
    let className = '';
    let icon = undefined;

    switch (drawStatus) {
        case DrawStatus.InProgress:
            className = 'box-gray';
            icon = faClock;
            break;
        case DrawStatus.Request:
            className = 'box-yellow';
            icon = faEnvelope;
            break;
        case DrawStatus.Inspecting:
            className = 'box-blue';
            icon = faTruckArrowRight;
            break;
        case DrawStatus.NeedToFund:
            className = 'box-red';
            icon = faHouseCircleExclamation;
            break;
        case DrawStatus.NotFinalized:
            className = 'box-orange';
            icon = faCheckSquare;
            break;
        case DrawStatus.Finalized:
            className = 'box-green';
            icon = faBank;
            break;
    }

    return (
        <div
            className={className}
            style={{ textAlign: 'center' }}
        >
            {icon && (
                <FontAwesomeIcon
                    icon={icon}
                    size={'1x'}
                />
            )}
        </div>
    );
};
